import { createSlice } from "@reduxjs/toolkit";
import { IAppInfoState } from "./app-model";

const initialAppInfoState: IAppInfoState = {
    isPricingOpen: false,
    isFaqOpen: false
};

const appInfoSlice = createSlice({
    name: "pricing",
    initialState: initialAppInfoState,
    reducers: {
        togglePricingDialog: (state) => {
            state.isPricingOpen = !state.isPricingOpen;
        },
        toggleFaqDialog: (state) => {
            state.isFaqOpen = !state.isFaqOpen;
        }
    }
});

export const { togglePricingDialog, toggleFaqDialog } = appInfoSlice.actions;
export default appInfoSlice;
